document.addEventListener("turbolinks:load", function() {
	$(document).on("change","#mass_check", function() {
		$("input:checkbox.mass_check").prop('checked', $(this).prop("checked"));
	});
})
